import { topics } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">热门话题</h2>
        <p className="text-sm text-foreground-500 mb-10">大家都在关注的热门内容方向，看看有没有你感兴趣的</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className="group flex items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5">
                  <span className="text-sm font-semibold text-foreground-800 truncate">{topic.name}</span>
                  {topic.hot && (
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0"></span>
                  )}
                </div>
                <span className="text-xs text-foreground-400">{topic.count}次浏览</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}